import React, { useState, useEffect } from "react";
import { Toggle } from "@fluentui/react/lib/Toggle";
import Select from "react-select";

const ShippingAndBillingAddress = ({
  formData,
  handleChange,
  setFormData,
  invalidFields,
  shippingZipCodeError, setShippingZipCodeError,
  billingZipCodeError, setBillingZipCodeError,
  showBillingDetails, setShowBillingDetails, handleToggleChange,
  touchedFields, // Add touched fields prop
  setTouchedFields, // Add setter for touched fields
  setInvalidFields
}) => {
  const [filteredStates, setFilteredStates] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);

  const [bfilteredStates, bsetFilteredStates] = useState([]);
  const [bfilteredCities, bsetFilteredCities] = useState([]);

  useEffect(() => {
    const addressesSameValue = localStorage.getItem("addressesSame");
    if (addressesSameValue === "1") {
      setShowBillingDetails(false); // Hide billing details initially if addresses are the same
    }
  }, [setShowBillingDetails]);

  const fetchStates = async (country, isBilling = false) => {
    if (!country) return;

    try {
      const token = localStorage.getItem("auth-token");

      // Fetch country ID
      const countryResponse = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/optionsetData/get-country-guid`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ countryName: country, tokenData: token }),
      });

      if (!countryResponse.ok) throw new Error('Failed to fetch country ID');

      const countryData = await countryResponse.json();
      const countryId = countryData.value[0].nyc_countryid;
      console.log(countryId);

      // Fetch states
      const statesResponse = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/optionsetData/get-states`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ countryId, tokenData: token }),
      });

      if (!statesResponse.ok) throw new Error('Failed to fetch states');

      const statesData = await statesResponse.json();
      const states = Array.isArray(statesData.value) ? statesData.value : [];

      if (isBilling) {
        bsetFilteredStates(states);
      } else {
        setFilteredStates(states);
      }
    } catch (error) {
      console.error('Error fetching states:', error);
    }
  };

  const fetchCities = async (stateId, isBilling = false) => {
    if (!stateId) return;

    try {
      const token = localStorage.getItem("auth-token");

      // Fetch cities for the selected state
      const citiesResponse = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/optionsetData/get-cities`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ stateId, tokenData: token }),
      });

      if (!citiesResponse.ok) throw new Error('Failed to fetch cities');

      const citiesData = await citiesResponse.json();
      const cities = Array.isArray(citiesData.value) ? citiesData.value : [];
      // Add "Not Applicable" if there are no cities
      if (isBilling) {
        bsetFilteredCities(cities);
      } else {
        setFilteredCities(cities);
      }
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  useEffect(() => {
    if (formData.shippingCountry) {
      fetchStates(formData.shippingCountry);
    }
  }, [formData.shippingCountry]);

  useEffect(() => {
    if (formData.billingCountry) {
      fetchStates(formData.billingCountry, true);
    }
  }, [formData.billingCountry]);

  useEffect(() => {
    if (formData.shippingState) {
      const selectedState = filteredStates.find(state => state.nyc_name === formData.shippingState);
      if (selectedState) {
        fetchCities(selectedState.nyc_stateid);
      }
    }
  }, [formData.shippingState, filteredStates]);

  useEffect(() => {
    if (formData.billingState) {
      const selectedState = bfilteredStates.find(state => state.nyc_name === formData.billingState);
      if (selectedState) {
        fetchCities(selectedState.nyc_stateid, true);
      }
    }
  }, [formData.billingState, bfilteredStates]);

  const countryZipRegex = {
    CA: /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/, // Canada
    UK: /^([A-Za-z]{2}\d{1,2}[A-Za-z]?)\s*(\d[\dA-Za-z]{2})$/, // UK
    US: /^[0-9]{5}(?:-[0-9]{4})?$/, // US
  };

  const validateZipCode = (country, zipCode, setError) => {
    const regex = countryZipRegex[country];
    setError(regex && !regex.test(zipCode) ? "Invalid zip code format" : "");
  };

  const handleShippingZipCodeChange = (e) => {
    const { value } = e.target;
    handleChange(e);
    validateZipCode(formData.shippingCountry, value, setShippingZipCodeError);
   
    if (!showBillingDetails) {
        // Copy the shipping zip code to billing zip code when billing details are hidden
        handleChange({
            target: { name: 'billingZipCode', value }
        }); // Simulating a change event to update billing zip code
        validateZipCode(formData.billingCountry, value, setBillingZipCodeError);
    }
 
    // setShowBillingDetails(true);
};


  const handleBillingZipCodeChange = (e) => {
    const { value } = e.target;
    handleChange(e); // Propagate change to parent component
    validateZipCode(formData.billingCountry, value, setBillingZipCodeError);
  };
  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
   
    setFormData((prevData) => ({
      ...prevData,
      shippingCountry: selectedCountry,
      shippingState: "",
      shippingCity: "",
      shippingZipCode: "",
    }));
   
    if (selectedCountry) {
      fetchStates(selectedCountry);
    }
   
    handleChange(e); // Propagate change to parent component
   
    if (!showBillingDetails) {
      // If billing details are hidden, copy shipping country to billing country
      setFormData((prevData) => ({
        ...prevData,
        billingCountry: selectedCountry,
        billingState: "",
        billingCity: "",
        billingZipCode: "",
      }));
   
      if (selectedCountry) {
        fetchStates(selectedCountry, true); // Fetch billing states based on the selected shipping country
      }
   
      handleChange({
        target: { name: 'billingCountry', value: selectedCountry }
      });
    }
   
    // setShowBillingDetails(true);
    // handleToggleChange();
  };

  const bhandleCountryChange = (e) => {
    const bselectedCountry = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      billingCountry: bselectedCountry,
      billingState: "",
      billingCity: "",
      billingZipCode: "",
    }));
    if (bselectedCountry) {
      fetchStates(bselectedCountry, true);
    }
    handleChange(e);
  };

  const stateOptions = filteredStates.map((state) => ({
    value: state.nyc_name,
    label: state.nyc_name,
  }));

  // const cityOptions = filteredCities.map((city) => ({
  //   value: city.nyc_name,
  //   label: city.nyc_name,
  // }));
  const cityOptions = filteredCities.length
  ? filteredCities.map((city) => ({
      value: city.nyc_name,
      label: city.nyc_name,
    }))
  : [{ value: "Not Applicable", label: "Not Applicable" }];

  const billStateOptions = bfilteredStates.map((state) => ({
    value: state.nyc_name,
    label: state.nyc_name,
  }));

  const billCityOptions = bfilteredCities.length
  ?bfilteredCities.map((city) => ({
    value: city.nyc_name,
    label: city.nyc_name,
  }))
  : [{ value: "Not Applicable", label: "Not Applicable" }];

  const handleShippingBillingChange = (name) => (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: selectedOption ? selectedOption.value : "",
    }));
 
    if (name === "shippingState") {
      setFormData((prevData) => ({
        ...prevData,
        shippingCity: "", // Clear the shipping city when shipping state changes
      }));
 
      if (!showBillingDetails) {
        // If billing details are hidden, copy the shipping state to billing state
        setFormData((prevData) => ({
          ...prevData,
          billingState: selectedOption ? selectedOption.value : "",
          billingCity: "", // Clear billing city when state changes
        }));
      }
    }
 
    if (name === "billingState") {
      setFormData((prevData) => ({
        ...prevData,
        billingCity: "", // Clear billing city when billing state changes
      }));
    }
 
    if (name === "shippingCity") {
      if (!showBillingDetails) {
        // If billing details are hidden, copy the shipping city to billing city
        setFormData((prevData) => ({
          ...prevData,
          billingCity: selectedOption ? selectedOption.value : "",
        }));
      }
    }
   
    // Uncomment these lines if you need to show billing details or handle toggle change
    // setShowBillingDetails(true);
    // handleToggleChange();

    // Mark field as touched
    setTouchedFields((prevTouched) => ({
      ...prevTouched,
      [name]: true,
    }));
 
    // Remove from invalid fields if value is set
    if (selectedOption && selectedOption.value) {
      setInvalidFields((prevInvalidFields) =>
        prevInvalidFields.filter((field) => field !== name)
      );
    }
 
    handleChange();
  };

  return (
    <div className="client-info-container">
      {/* Shipping Details */}
      <div className="sub-container">
        <h3 className='heading3'>Shipping Details</h3>
        {/* Address Line 1 */}
        <div className="input-field-row nycfix-input-row">
          <div className="column nycfix-field">
            <label className="label flex gap-0.5">
              Shipping Address Line 1
              <span className="text-red-700 font-semibold text-md">*</span>
              {invalidFields.includes("shippingAddressLine1") && (
                <p className="text-red-700 font-semibold text-md">
                  This field is required.
                </p>
              )}
            </label>
            <input
              className={`input ${invalidFields.includes("shippingAddressLine1") ? "invalid" : ""}`}
              type="text"
              name="shippingAddressLine1"
              value={formData.shippingAddressLine1}
              onChange={handleChange}
              placeholder="---"
              required
            />
          </div>
          <div className="column">
            <label className="label flex gap-0.5">
              Shipping Address Line 2
            </label>
            <input
              className="input"
              type="text"
              name="shippingAddressLine2"
              value={formData.shippingAddressLine2}
              onChange={handleChange}
              placeholder="---"
            />
          </div>
        </div>

        {/* Country, State, City, Zip Code */}
        <div className="input-field-row nycfix-input-row">
          <div className="column nycfix-field">
            <label className="label flex gap-0.5">
              Shipping Country
              <span className="text-red-700 font-semibold text-md">*</span>
              {invalidFields.includes("shippingCountry") && (
                <p className="text-red-700 font-semibold text-md">
                  This field is required.
                </p>
              )}
            </label>
            <select
              name="shippingCountry"
              className="selectStyle"
              value={formData.shippingCountry}
              onChange={handleCountryChange}
              required
            >
              <option value="">--Select--</option>
              <option value="CA">Canada</option>
              <option value="US">United States</option>
              <option value="UK">United Kingdom</option>
            </select>
          </div>
          <div className="column">
            <label className="label flex gap-0.5">
              Shipping State
              <span className="text-red-700 font-semibold text-md">*</span>
              {invalidFields.includes("shippingState") && touchedFields.shippingState && (
                <p className="text-red-700 font-semibold text-md">
                  This field is required.
                </p>
              )}
            </label>
            <Select
              name="shippingState"
              value={stateOptions.find(option => option.value === formData.shippingState) || null}
              onChange={handleShippingBillingChange("shippingState")}
              options={stateOptions}
              placeholder="--Select--"
              isClearable
              required
            />
          </div>
        </div>

        {/* City and Zip Code */}
        <div className="input-field-row nycfix-input-row">
          <div className="column nycfix-field">
            <label className="label flex gap-0.5">
              Shipping City
              <span className="text-red-700 font-semibold text-md">*</span>
              {invalidFields.includes("shippingCity")&& touchedFields.shippingCity &&  (
                <p className="text-red-700 font-semibold text-md">
                  This field is required.
                </p>
              ) }
            </label>
            <Select
              name="shippingCity"
              value={cityOptions.find(option => option.value === formData.shippingCity) || null}
              onChange={handleShippingBillingChange("shippingCity")}
              options={cityOptions}
              placeholder="--Select--"
              isClearable
              required
            />
          </div>
          <div className="column">
            <label className="label flex gap-0.5">
              Shipping Zip Code
              <span className="text-red-700 font-semibold text-md">*</span>
              {shippingZipCodeError.length > 0 ? (
                <p className="text-red-700 font-semibold text-md">
                  Invalid Zip Code format
                </p>
              ) : (
                invalidFields.includes("shippingZipCode") && (
                  <p className="text-red-700 font-semibold text-md">
                    This field is required.
                  </p>
                )
              )}
            </label>
            <input
              className={`input ${invalidFields.includes("shippingZipCode") ? "invalid" : ""}`}
              type="text"
              name="shippingZipCode"
              value={formData.shippingZipCode}
              onChange={handleShippingZipCodeChange}
              placeholder="---"
              required
            />
          </div>
        </div>
      </div>

      {/* Toggle for Billing Address */}
      <div className="sub-container">
        <div className="input-field-row nycfix-input-row">
          <div className="column nyxfix-field">
            <Toggle
              label="Are shipping & billing addresses the same"
              checked={!showBillingDetails} // Inverse of showBillingDetails
              onChange={(event, checked) => handleToggleChange(checked)}
            />
          </div>
        </div>
      </div>

      {/* Billing Details */}
      {showBillingDetails && (
        <div className="sub-container">
          <h3 className='heading3'>Billing Details</h3>
          {/* Address Line 1 */}
          <div className="input-field-row nycfix-input-row">
            <div className="column nycfix-field">
              <label className="label flex gap-0.5">Billing Street Address 
              <span className="text-red-700 font-semibold text-md">*</span>
              {invalidFields.includes("billingStreetAddress") && (
                <p className="text-red-700 font-semibold text-md">
                  This field is required.
                </p>
              )}
              </label>
              <input
                type="text"
                className="input"
                name="billingStreetAddress"
                value={formData.billingStreetAddress}
                onChange={handleChange}
                placeholder="---"
              />
            </div>
            <div className="column">
              <label className="label flex gap-0.5">Billing Suite/Dock or Apt</label>
              <input
                type="text"
                className="input"
                name="billingSuite"
                value={formData.billingSuite}
                onChange={handleChange}
                placeholder="---"
              />
            </div>
          </div>

          {/* Country, State, City, Zip Code */}
          <div className="input-field-row nycfix-input-row">
            <div className="column nycfix-field">
              <label className="label flex gap-0.5">Billing Country
              <span className="text-red-700 font-semibold text-md">*</span>
              {invalidFields.includes("billingCountry") && (
                <p className="text-red-700 font-semibold text-md">
                  This field is required.
                </p>
              )}
              </label>
              <select
                name="billingCountry"
                className="selectStyle"
                value={formData.billingCountry}
                onChange={bhandleCountryChange}
              >
                <option value="">--Select--</option>
                <option value="CA">Canada</option>
                <option value="US">United States</option>
                <option value="UK">United Kingdom</option>
              </select>
            </div>
            <div className="column">
              <label className="label flex gap-0.5">Billing State 
              <span className="text-red-700 font-semibold text-md">*</span>
              {invalidFields.includes("billingState") && touchedFields.billingState && (
                <p className="text-red-700 font-semibold text-md">
                  This field is required.
                </p>
              ) }
              </label>
              <Select
                name="billingState"
                value={billStateOptions.find(option => option.value === formData.billingState)}
                onChange={handleShippingBillingChange("billingState")}
                options={billStateOptions}
                placeholder="--Select--"
                isClearable
                required
              />
            </div>
          </div>

          {/* City and Zip Code */}
          <div className="input-field-row nycfix-input-row">
            <div className="column nycfix-field">
              <label className="label flex gap-0.5">Billing City
              <span className="text-red-700 font-semibold text-md">*</span>
              {invalidFields.includes("billingCity") && touchedFields.billingCity && (
                <p className="text-red-700 font-semibold text-md">
                  This field is required.
                </p>
              ) }
              </label>
              <Select
                name="billingCity"
                value={billCityOptions.find(option => option.value === formData.billingCity) || null}
                onChange={handleShippingBillingChange("billingCity")}
                options={billCityOptions}
                placeholder="--Select--"
                isClearable
                required
              />
            </div>
            <div className="column">
              <label className="label flex gap-0.5">
                Billing Zip Code
                <span className="text-red-700 font-semibold text-md">*</span>
                 {billingZipCodeError.length > 0 ? (
                  <p className="text-red-700 font-semibold text-md">
                    Invalid Zip Code format
                  </p>
                ) : (
                  invalidFields.includes("billingZipCode") && (
                    <p className="text-red-700 font-semibold text-md">
                      This field is required.
                    </p>
                  )
                )}
              </label>
              <input
                className={`input ${invalidFields.includes("billingZipCode") ? "invalid" : ""}`}
                type="text"
                name="billingZipCode"
                value={formData.billingZipCode}
                onChange={handleBillingZipCodeChange}
                placeholder="---"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShippingAndBillingAddress;